export const MANAGEABLE_BASE_COLUMNS = [
  { key: "agentCheckIn", label: "Agent Check-in", onlyAllDevices: false },
  { key: "battery", label: "Battery", onlyAllDevices: false },
  { key: "chargingStatus", label: "Charging", onlyAllDevices: false },
  { key: "networkSsid", label: "Network SSID", onlyAllDevices: false },
  { key: "hasIp", label: "IP", onlyAllDevices: false },
  { key: "folderPath", label: "Folder Path", onlyAllDevices: true },
  { key: "currentFolder", label: "Current Folder" },
  { key: "notes", label: "Notes", onlyAllDevices: false, editable: true },
  { key: "inKiosk", label: "In Kiosk", onlyAllDevices: false },
  { key: "status", label: "Status", onlyAllDevices: false },
];

export const OPTIONAL_TIME_COLUMNS = [
  {
    key: "brandingConfigTime",
    label: "Time Branding Config",
    actionKey: "fetch_branding_config_log",
  },
  {
    key: "scanAndGoConfigTime",
    label: "Time Scan and go Config",
    actionKey: "fetch_scan_and_go_config_log",
  },
  {
    key: "deviceConfigTime",
    label: "Time Device Config",
    actionKey: "fetch_device_config_log",
  },
];

export const OPTIONAL_PAYLOAD_CACHE_COLUMNS = [
  { key: "app_in_idle", label: "S&G_app_in_idle", payloadKeys: ["app_in_idle"], valueKind: "boolean" },
  { key: "wall_id", label: "S&G_wall_id", payloadKeys: ["wall_id"], valueKind: "string" },
  {
    key: "device_in_cradle",
    label: "S&G_device_in_cradle",
    payloadKeys: ["device_in_cradle"],
    valueKind: "boolean",
  },
  {
    key: "is_scan_and_go_ready",
    label: "is_scan_and_go_ready",
    payloadKeys: ["is_scan_and_go_ready"],
    valueKind: "boolean",
  },
  { key: "allowed", label: "S&G_allowed", payloadKeys: ["allowed"], valueKind: "boolean" },
  {
    key: "S&G_battery_level",
    label: "S&G_battery_level",
    payloadKeys: ["S&G_battery_level"],
    valueKind: "battery",
  },
  {
    key: "S&G_updated",
    label: "S&G_updated",
    payloadKeys: ["S&G_updated"],
    valueKind: "timestamp",
  },
  {
    key: "S&G_last_release_ts",
    label: "S&G_last_release_ts",
    payloadKeys: ["S&G_last_release_ts"],
    valueKind: "timestamp",
  },
  {
    key: "locationLogVersionUpdated",
    label: "Location Log (App / Updated)",
    payloadKeys: ["location_log"],
    valueKind: "locationVersionUpdated",
  },
  {
    key: "ncrStatus",
    label: "NCR Status",
    payloadKeys: ["ncr_status"],
    valueKind: "ncrStatus",
  },
];

export const DEFAULT_ACTIVE_MANAGED_COLUMN_KEYS = MANAGEABLE_BASE_COLUMNS.map((column) => column.key);

export const ALL_MANAGED_COLUMN_KEYS = new Set([
  ...MANAGEABLE_BASE_COLUMNS.map((column) => column.key),
  ...OPTIONAL_TIME_COLUMNS.map((column) => column.key),
  ...OPTIONAL_PAYLOAD_CACHE_COLUMNS.map((column) => column.key),
]);

export const sanitizeActiveManagedColumnKeys = (keys) => {
  if (!Array.isArray(keys)) return null;

  const sanitized = [];
  const seen = new Set();
  keys.forEach((key) => {
    if (typeof key !== "string" || !ALL_MANAGED_COLUMN_KEYS.has(key) || seen.has(key)) return;
    seen.add(key);
    sanitized.push(key);
  });

  return sanitized;
};
